import React, { Component } from 'react';
import {Button, Checkbox, Form, Input, List, message, Popover, Select, Spin, Upload} from "antd";
import {MinusCircleOutlined, PlusOutlined,UploadOutlined} from "@ant-design/icons";
import SerialModel from "./model/SerialModel";
import DifferentSerialNumber from './differentCustomer/differentSerialNumber';
import TextArea from "antd/es/input/TextArea";
import MassModel from "../wepcg/model/massModel";
import {mass_upload} from "../../../requist";

const {Option} = Select

const formItemLayoutWithOutLabel = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8,offset:2 },
    },
    wrapperCol: {
        xs: { span: 20 },
        sm: { span: 10 },
    },
};

const downLoadFiles={
    "DOA":'assets/downLoadFile/WE_DCG_DOA_Mass_upload_template.xlsx',
}

class SerialNumber extends Component{
    constructor(props) {
        super(props);
        this.state={
            full_invoice_Claim_Checked: false,
            fileList:[],
            MassModelData:[]
        }
        
    }
    FullinvoiceClaimChecked=(e)=>{
        this.setState({full_invoice_Claim_Checked:e.target.checked})
    }
    fileMassProps(){
        let that = this
        return {
            name: 'file',
            maxCount:1,
            beforeUpload(file,fileList){
                // console.log(fileList[0])
                return false
            },
            onChange(info) {
                if (info.file.status !== 'uploading' && info.file.status!=='removed') {
                    that.setState({loading:true})
                    // console.log(info.file, info.fileList);
                    let data = new FormData();
                    data.append('file',info.file)
                    let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
                    const params = {
                        disputeType:that.props.disputeType,
                        region:'WE',
                        businessUnit:'D',
                        isPartnerHubUser:userInfo.source==='external',
                        templateFlag:'S'
                    }
                    mass_upload(data,params).then(res=>{
                        const {data,retCode,retMsg} = res;
                        if(retCode==="200"){
                            that.setState({MassModelVisible:true,MassModelData:data,loading:false})
                        }else{
                            message.warn(`${retMsg}`)
                        }
                    })
                }
                if (info.file.status === 'done') {
                    message.success(`${info.file.name} file uploaded successfully`);

                } else if (info.file.status === 'error') {
                    message.error(`${info.file.name} file upload failed.`);
                }
            },
        };
    }
    MassOK=()=>{
        this.setState({MassModelVisible:false})
    }
    MassCancel=()=>{
        this.setState({MassModelVisible:false})
    }
    render() {
        let {MassModelData,full_invoice_Claim_Checked} = this.state;
        return <div>
                <div className="example" style={{display:this.state.loading?'block':'none'}}>
                    <Spin spinning={this.state.loading} />
                </div>
                <SerialModel
                    {...this.props}
                    serial_number={this.props.serial_number}
                    selectedRowKeys={this.props.selectedRowKeys}
                    dataChecked={this.props.dataChecked}
                    ModalVisible={this.props.isModalVisible}
                    handleOk={this.props.callback}
                    handleCancel={this.props.handleCancel}
                />
            {this.state.MassModelVisible ?
                <MassModel
                    {...this.props}
                    handleOk={this.MassOK}
                    onCancel={this.MassCancel}
                    flag={'WED'}
                    full_invoice_Claim_Checked={full_invoice_Claim_Checked}
                    data={MassModelData}
                    ModalVisible={this.state.MassModelVisible}/>
                :
                ''}
                    {/*<Form.Item*/}
                    {/*    label="Mass Upload"*/}
                    {/*    rules={[{ required: false}]}*/}
                    {/*    name={"MassUpload"}*/}
                    {/*    valuePropName={'checked'}*/}
                    {/*>*/}
                    {/*    <Checkbox onChange={this.FullinvoiceClaimChecked} ></Checkbox>*/}
                    {/*</Form.Item>*/}
                {full_invoice_Claim_Checked?
                <div className="spaceBox spaceHeaderBox">
                    <Form.Item
                    className={'addFormBtn'}
                    label="Claim Details"
                >
                    </Form.Item>
                    <Form.Item
                        label={<a href={downLoadFiles.DOA} download={downLoadFiles.DOA} style={{color:'#dc291e'}}>Mass Invoice Upload</a> }
                        name="Mass Invoice Upload"
                        rules={[{ required: true }]}
                    >
                        <Upload {...this.fileMassProps()}>
                            <Button icon={<UploadOutlined />}>Upload</Button>
                        </Upload>
                    </Form.Item>
                    <p style={{color:'#dc291e',marginLeft: '42%'}}>Please click 'Mass invoice Upload' field to download mass upload template</p>
                </div>
                :
                <div>
                    {this.props.InvoiceClaimMsg?
                        <div className="spaceBox spaceHeaderBox">
                            <DifferentSerialNumber {...this.props} />
                            <Form.List name="template1">
                                {(fields, { add, remove }) => (
                                    <>
                                        <Form.Item
                                            className={'addFormBtn'}
                                            label="Claim Details"
                                        >
                                            <Button className={'addBtn'} onClick={() => {add()}} type="dashed" icon={<PlusOutlined />}>

                                            </Button>
                                        </Form.Item>
                                        {fields.sort(function (a, b) {
                                            return b.name - a.name;
                                        }).map(({ key, name, fieldKey, field, index, ...restField }) => (
                                            <div key={key} className="spaceBox">
                                                <Form.Item
                                                    {...formItemLayoutWithOutLabel}
                                                    label="Serial Number"
                                                    {...restField}
                                                    name={[name,'serialNumber']}
                                                    fieldKey={[fieldKey, 'serialNumber']}
                                                    rules={[{ required: true }]}
                                                >
                                                    <Input />
                                                    <MinusCircleOutlined onClick={() => remove(name)} />
                                                </Form.Item>
                                                <Form.Item
                                                    label="DOA Period Confirmation Number"
                                                    {...restField}
                                                    name={[name, 'doaConfirmNo']}
                                                    fieldKey={[fieldKey, 'doaConfirmNo']}
                                                    rules={[{ required: true }]}
                                                >
                                                    <Input maxLength={10} />
                                                </Form.Item>
                                                <Form.Item
                                                    label="BIOS Password"
                                                    {...restField}
                                                    name={[name, 'biosPassword']}
                                                    fieldKey={[fieldKey, 'biosPassword']}
                                                    rules={[{ required: false }]}
                                                >
                                                    <Input maxLength={20} />
                                                </Form.Item>
                                            </div>
                                        ))}
                                    </>
                                )}
                            </Form.List>
                        </div>
                        :
                        <div className="spaceBox spaceHeaderBox">
                            <Form.List name="template1">
                                {(fields, { add, remove }) => (
                                    <>
                                        <Form.Item
                                            className={'addFormBtn'}
                                            label="Claim Details"
                                        >
                                            <Button className={'addBtn'} onClick={() => {add()}} type="dashed" icon={<PlusOutlined />}>

                                            </Button>
                                        </Form.Item>
                                        {fields.sort(function (a, b) {
                                            return b.name - a.name;
                                        }).map(({ key, name, fieldKey, field, index, ...restField }) => (
                                            <div key={key} className="spaceBox">
                                                <Form.Item
                                                    {...formItemLayoutWithOutLabel}
                                                    label="Serial Number"
                                                    {...restField}
                                                    name={[name,'serialNumber']}
                                                    fieldKey={[fieldKey, 'serialNumber']}
                                                    rules={[{ required: true }]}
                                                >
                                                    <Input fieldKey={name} suffix={<div>
                                                        <Button type="primary" onClick={this.props.ModalVisible}>Validate</Button>
                                                        <MinusCircleOutlined onClick={() => remove(name)} />
                                                    </div>}/>
                                                </Form.Item>
                                                <Form.Item
                                                    label="Sold To"
                                                    {...restField}
                                                    name={[name, 'soldToNumber']}
                                                    fieldKey={[fieldKey, 'soldToNumber']}
                                                    rules={[{ required: false}]}
                                                >
                                                    <Input disabled />
                                                </Form.Item>
                                                <Form.Item
                                                    label="PO Number"
                                                    {...restField}
                                                    name={[name, 'poNumber']}
                                                    fieldKey={[fieldKey, 'poNumber']}
                                                    rules={[{ required: false }]}
                                                >
                                                    <Input disabled />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Delivery Number"
                                                    {...restField}
                                                    name={[name, 'deliveryNumber']}
                                                    fieldKey={[fieldKey, 'deliveryNumber']}
                                                    rules={[{ required: false }]}
                                                >
                                                    <Input disabled />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Order Number"
                                                    {...restField}
                                                    name={[name, 'orderNumber']}
                                                    fieldKey={[fieldKey, 'orderNumber']}
                                                    rules={[{ required: false }]}
                                                >
                                                    <Input disabled />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Part Number"
                                                    {...restField}
                                                    name={[name, 'partNumber']}
                                                    fieldKey={[fieldKey, 'partNumber']}
                                                    rules={[{ required: true }]}
                                                >
                                                    <Input disabled />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Quantity"
                                                    {...restField}
                                                    name={[name, 'quantity']}
                                                    fieldKey={[fieldKey, 'quantity']}
                                                    rules={[{ required: true }]}
                                                    onChange={(e)=>{
                                                        this.props.onCreditAmountTotal(e,name)
                                                    }}
                                                >
                                                    <Input />
                                                </Form.Item>
                                                <Form.Item
                                                    label="BIOS Password"
                                                    {...restField}
                                                    name={[name, 'biosPassword']}
                                                    fieldKey={[fieldKey, 'biosPassword']}
                                                    rules={[{ required: false }]}
                                                >
                                                    <Input maxLength={20} />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Credit Amount Per Unit"
                                                    {...restField}
                                                    name={[name, 'creditAmountUnit']}
                                                    fieldKey={[fieldKey, 'creditAmountUnit']}
                                                    rules={[{ required: false }]}
                                                    onChange={(e)=>{
                                                        this.props.onCreditAmountTotal(e,name)
                                                    }}
                                                >
                                                    <Input />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Credit Amount Total"
                                                    {...restField}
                                                    name={[name, 'creditAmountTotal']}
                                                    fieldKey={[fieldKey, 'creditAmountTotal']}
                                                    rules={[{ required: false }]}
                                                >
                                                    <Input disabled />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Currency"
                                                    {...restField}
                                                    name={[name, 'currency']}
                                                    fieldKey={[fieldKey, 'currency']}
                                                    rules={[{ required: true }]}
                                                >
                                                    <Select placeholder='Please select'>
                                                        {
                                                            this.props.currencyList.map((item)=>{
                                                                return <Option value={item.key} >{item.value}</Option>
                                                            })
                                                        }
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        ))}
                                    </>
                                )}
                            </Form.List>
                    <Form.Item
                        label="Serial Number"
                        name={'serialNumber'}
                        rules={[{ required: true }]}
                    >
                        <Input suffix={<div>
                            <Button type="primary" onClick={this.props.ModalVisible}>Validate</Button>
                            <MinusCircleOutlined onClick={this.props.deleteFirstData}/>
                        </div>}/>
                    </Form.Item>
                    <Form.Item
                        label="Sold To"
                        name={'soldToNumber'}
                        rules={[{ required: false }]}
                    >
                        <Input disabled />
                    </Form.Item>
                    <Form.Item
                        label="PO Number"
                        name={'poNumber'}
                        rules={[{ required: false }]}
                    >
                        <Input disabled />
                    </Form.Item>
                    <Form.Item
                        label="Delivery Number"
                        name={'deliveryNumber'}
                        rules={[{ required: false}]}
                    >
                        <Input disabled />
                    </Form.Item>
                    <Form.Item
                        label="Order Number"
                        name={'orderNumber'}
                        rules={[{ required: false }]}
                    >
                        <Input disabled />
                    </Form.Item>
                    <Form.Item
                        label="Part Number"
                        name={'partNumber'}
                        rules={[{ required: false}]}
                    >
                        <Input disabled />
                    </Form.Item>
                    <Form.Item
                        label="Quantity"
                        name={'quantity'}
                        rules={[{ required: true }]}
                    >
                        <Input onChange={this.props.onCreditAmountTotal} />
                    </Form.Item>
                    <Form.Item
                        label="BIOS Password"
                        name={'biosPassword'}
                        rules={[{ required: false }]}
                    >
                        <Input maxLength={20} />
                    </Form.Item>
                    <Form.Item
                        label="Credit Amount Per Unit"
                        name={'creditAmountUnit'}
                        rules={[{ required: false }]}
                    >
                        <Input onChange={this.props.onCreditAmountTotal} />
                    </Form.Item>
                    <Form.Item
                        label="Credit Amount Total"
                        name={'creditAmountTotal'}
                        rules={[{ required: false }]}
                    >
                        <Input disabled />
                    </Form.Item>
                    <Form.Item
                        label="Currency"
                        name={'currency'}
                        rules={[{ required: true}]}
                    >
                        <Select placeholder={'Please select'}>
                            {
                                this.props.currencyList.map((item)=>{
                                    return <Option value={item.key} >{item.value}</Option>
                                })
                            }
                        </Select>
                    </Form.Item>

                </div>
                }
                    
                </div>
            }
                
                
        </div>

    }

}

export default SerialNumber;